import { render, staticRenderFns } from "./VirtualAccountInvoiceInfo.vue?vue&type=template&id=5c158576"
import script from "./VirtualAccountInvoiceInfo.vue?vue&type=script&lang=js"
export * from "./VirtualAccountInvoiceInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c158576')) {
      api.createRecord('5c158576', component.options)
    } else {
      api.reload('5c158576', component.options)
    }
    module.hot.accept("./VirtualAccountInvoiceInfo.vue?vue&type=template&id=5c158576", function () {
      api.rerender('5c158576', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settle/popup/VirtualAccountInvoiceInfo.vue"
export default component.exports